// Anonymous play stats. Each browser gets a random id per puzzle so a
// refresh doesn't count as a new player. No personal data is sent.
import { API_BASE } from "../config";

const playerId = (gameId: string): string => {
  const key = `matchset-play-${gameId}`;
  try {
    let id = localStorage.getItem(key);
    if (!id) {
      id = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(key, id);
    }
    return id;
  } catch {
    return Math.random().toString(36).slice(2); // storage blocked: count anyway
  }
};

type PlayEvent =
  | { type: "start" }
  | { type: "finish"; won: boolean; tries: number; seconds: number };

export const recordPlay = (gameId: string, event: PlayEvent): void => {
  try {
    fetch(`${API_BASE}/api/games/${gameId}/plays`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ playerId: playerId(gameId), ...event }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* stats must never break the game */
  }
};
